var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.371,
    height: 39.281,
    viewBox: "0 0 34.371 39.281",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4508",
    "data-name": "Path 4508",
    d: "M0,318.127A13.906,13.906,0,0,1,13.679,304h7.012a13.906,13.906,0,0,1,13.679,14.127,2.317,2.317,0,0,1-2.279,2.353H2.279A2.317,2.317,0,0,1,0,318.127Z",
    transform: "translate(0 -281.199)",
    fill: "#047BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4509",
    "data-name": "Path 4509",
    d: "M96,10.142a9.595,9.595,0,1,1,19.159,0,9.595,9.595,0,1,1-19.159,0Z",
    transform: "translate(-88.394)",
    fill: "#888",
    opacity: 0.4
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.a4463a7565f97f84e34b7974314f4ba2.svg";